import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import Checkbox from '@components/Checkbox';

export default function CheckboxField({
  label, ...props
}) {
  const [field, meta] = useField({ ...props, type: 'checkbox' });

  return (
    <Checkbox
      label={label}
      error={meta.touched && !!meta.error}
      field={field}
      {...props}
    />
  );
}

CheckboxField.defaultProps = {
  checked: false,
};

CheckboxField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
};
